module.exports = __webpack_public_path__ + "static/media/Daisy.9eed5cdb.png";